// The backend uses the same values in the "is a timestamp" condition
export const MIN_UNIX_TIMESTAMP = 99999999;
export const MAX_UNIX_TIMESTAMP = 10000000000;
export function isValidTimestamp(timestamp) {
  // if the timestamp string contains anything other than numbers
  if (/\D/.test(timestamp)) {
    return false;
  }
  let value = Number(timestamp);
  return Number.isInteger(value) && value > MIN_UNIX_TIMESTAMP && value < MAX_UNIX_TIMESTAMP;
}